import React from 'react';

const NoMatch = () => {
  return (
    <div>
      <h4>No Route was matching</h4>
    </div>
  );
};

export default NoMatch;
